import { Edit } from "@mui/icons-material";
import { Button, ListItemIcon, MenuItem } from "@mui/material";
import { labelButtonStyle } from "../../../../components/shared/PopupMenu";
import { PlanTableFormat } from "../../../../types/planning/plan.type";

import { useActionsMenuContext } from "../../shared/ActionsMenuContext";

type EditMenuItemProps = {
  routeOrTrap: PlanTableFormat;
  handleClose?: () => void;
  clearSelection?: () => void;
};

export const EditMenuItem = ({
  routeOrTrap,
  handleClose,
  clearSelection,
}: EditMenuItemProps) => {
  const { openDialog } = useActionsMenuContext();
  return (
    <MenuItem
      onClick={() => {
        handleClose?.();
        openDialog({
          name: "edit-route-trap",
          planSummaries: [routeOrTrap],
          clearSelection,
        });
      }}
    >
      <ListItemIcon>
        <Edit />
      </ListItemIcon>
      <Button sx={labelButtonStyle} disableRipple>
        Edit
      </Button>
    </MenuItem>
  );
};
